// extracted by mini-css-extract-plugin
export default {"heatmaps":"Heatmaps_heatmaps__rO5oT"};